import { DiscoveryGraph } from "../../../components/discovery/DiscoveryGraph";
import { logEventLineageGraphImpression } from "../../../utils/analytics/eventLogging";

export function LineageDiscoveryPage(): JSX.Element {
  return <DiscoveryGraph onInitialNodesRender={logEventLineageGraphImpression} />;
}
